import moment from 'moment';
const calculateOrderReadyTime = (order, dateTime = true) => {
  let orderReadyTime;
  if (
    (!order?.is_future_order && order?.order_type === 'pickup') ||
    (!order?.is_future_order &&
      order?.order_type === 'delivery' &&
      order?.delivery_provider === 'delivery_by_restaurant') ||
    (!order?.is_future_order && order?.order_type === 'drop_off')
  ) {
    orderReadyTime = moment(order?.order_created_at)
      .add(
        moment
          .duration(moment(order?.min_prep_time, 'HH:mm:ss').format('HH:mm'))
          .asMinutes(),
        'minutes'
      )
      .format(dateTime ? 'YYYY-MM-DD HH:mm:ss' : 'hh:mm A');
  } else {
    orderReadyTime = moment(order?.order_date).format(
      dateTime ? 'YYYY-MM-DD HH:mm:ss' : 'hh:mm A'
    );
  }

  return orderReadyTime;
};

export default calculateOrderReadyTime;
